import { render, staticRenderFns } from "./VacuumPanels.vue?vue&type=template&id=78e0d467&scoped=true&"
import script from "./VacuumPanels.vue?vue&type=script&lang=js&"
export * from "./VacuumPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0d467",
  null
  
)

export default component.exports